/* import __COLOCATED_TEMPLATE__ from './submenu-footer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();